import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  ${media.lessThan("medium")`
    grid-template-columns: 1fr;
  `}
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const Today = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }

  h1 {
    font-size: 40px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const Dates = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Date = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  p {
    font-size: 14px;
    color: ${({ theme, active }) =>
      active ? theme.colors.primary.green : theme.colors.neutral.cinza500};
  }
`;

export const DateMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }

  h3 {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  ${media.lessThan("medium")`
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  `}
`;

export const Calendar = styled.div`
  width: 100%;
  height: 100%;

  /* Variáveis do react-day-picker declaradas em ".months", e não em ".rdp-root".
     ⚠️ Duas armadilhas encontradas aqui (20/08/2026), as duas medidas no
     navegador:

     1. O componente remapeia só ALGUMAS classes (day, selected, today, months…)
        e "root" NÃO está no mapa — a raiz fica com a classe HASHEADA do CSS
        module. O antigo bloco ".rdp-root { --rdp-* }" nunca casou com nada:
        era CSS morto. Declarar no wrapper styled também não resolve, porque a
        raiz da biblioteca (descendente do wrapper) redeclara os próprios
        defaults e ganha por proximidade. ".months" é remapeada E fica ENTRE a
        raiz e os dias — é onde a declaração vence.

     2. --rdp-disabled-opacity valia 0.5, e os dias marcados (os únicos com a
        classe "disabled") saíam a 50% de branco: cinza ilegível no fundo
        escuro. Era exatamente o que o cliente reportou. */
  .months {
    --rdp-font-family: ${({ theme }) => theme.font.fontFamily};
    --rdp-selected-font: ${({ theme }) => theme.font.fontFamily};
    --rdp-accent-color: ${({ theme }) => theme.colors.primary.green};
    --rdp-today-color: ${({ theme }) => theme.colors.primary.green};
    --rdp-day-color: ${({ theme }) => theme.colors.neutral.white};
    --rdp-disabled-opacity: 1;
  }

  .caption_label {
    z-index: 1;
    position: relative;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    border: 0;
    color: ${({ theme }) => theme.colors.primary.orange} !important;
  }

  .nav {
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    display: flex;
    align-items: center;
    height: var(--rdp-nav-height);
    gap: 15px !important;
  }

  .month_caption {
    display: flex;
    align-content: center;
    height: var(--rdp-nav-height);
    font: var(--rdp-month_caption-font);

    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.cinza500};
  }

  .button_next,
  .button_previous {
    svg {
      fill: ${({ theme }) => theme.colors.neutral.cinza500} !important;
    }
  }

  .day {
    font-family: ${({ theme }) => theme.font.fontFamily} !important;
    color: ${({ theme }) => theme.colors.neutral.white} !important;

    height: 2.9rem !important;

    cursor: not-allowed;
    pointer-events: none;
  }

  .today {
    position: relative;
    font-family: ${({ theme }) => theme.font.fontFamily} !important;
    color: ${({ theme }) => theme.colors.primary.green} !important;

    /* Mesma razão do .day_button acima: a cor tem de ir no botão. */
    .day_button {
      color: ${({ theme }) => theme.colors.primary.green} !important;
    }

    border-radius: 50% !important;

    ::after {
      position: absolute;
      top: 9%;
      left: 17.3%;
      z-index: 1;
      content: "";
      width: 65%;
      height: 80%;
      border-radius: 50%;
      outline: 1px solid ${({ theme }) => theme.colors.primary.green} !important;
    }
  }

  .selected {
    position: relative;

    font-family: ${({ theme }) => theme.font.fontFamily} !important;
    font-weight: bold !important;

    /* background-color: ${({ theme }) =>
      theme.colors.primary.green} !important; */
    color: ${({ theme }) => theme.colors.neutral.black} !important;
    border-radius: 50% !important;

    /* Marco do projeto: círculo verde com o número em PRETO por cima dele.
       ⚠️ O position/z-index aqui NÃO é decorativo: o ::after abaixo desenha o
       círculo com z-index 1 e, sem empilhar o botão acima dele, o círculo é
       pintado POR CIMA do número — a bolinha aparecia sólida e sem dia legível
       (relatado em 03/09/2026). A cor já era preta sobre o verde (contraste
       12:1); o que faltava era o número não ficar embaixo. */
    .day_button {
      position: relative;
      z-index: 2;
      color: ${({ theme }) => theme.colors.neutral.black} !important;
    }

    cursor: pointer !important;
    pointer-events: all !important;

    ::after {
      position: absolute;
      top: 9%;
      left: 16.3%;
      z-index: 1;
      content: "";
      width: 65%;
      height: 80%;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.primary.green};
    }
  }

  /* Dias dentro do período do projeto (project_start_at → project_finish_at).
     Fundo discreto: o destaque precisa ser lido como "faixa", sem competir com
     o círculo verde dos marcos nem apagar o número do dia. */
  .in_project {
    background-color: ${({ theme }) => theme.colors.primary.prim300}55;
  }

  /* Extremos da faixa arredondados, para ela parecer um intervalo e não uma
     sequência de quadrados soltos. */
  .in_project:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  .in_project:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .day_button {
    width: 100% !important;
    height: 100% !important;

    position: relative;
    z-index: 2;

    /* ⚠️ É AQUI que o número do dia é pintado. O ".day" é o <td>; o número vive
       num <button> dentro dele, e botão NÃO herda a cor (o user-agent aplica a
       própria). Por isso o branco do ".day" não chegava ao número, que saía
       preto no fundo escuro — praticamente invisível. Medido no navegador:
       td rgb(255,255,255) e button rgb(0,0,0).
       (Sem backtick em comentário: dentro de template literal ele fecha a string.) */
    color: ${({ theme }) => theme.colors.neutral.white} !important;
  }

  .months,
  .month {
    width: 100% !important;
    max-width: 100% !important;

    table {
      width: 100% !important;

      margin-top: 10px !important;
      table-layout: fixed;
    }
  }

  ${media.lessThan("medium")`
    .day {
      height: 2.8rem !important;
    }

    .selected::after {
      top: 7%;
      left: 9.3%;
      width: 80%;
      height: 80%;
    }

    .today::after {
      top: 8%;
      left: 10.3%;
      width: 80%;
      height: 80%;
    }
  `}
`;

// Nome do projeto na lista de datas: mesma aparência do <span> que havia antes,
// só com a afordância de link (sublinhado no hover).
export const ProjectLink = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.cinza200};
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;
